import React from 'react';
import {ChartData, ChartDataset, ChartOptions} from "chart.js";
import {Line as LineChart} from "react-chartjs-2";
import HoverAnnotation from "../../../plugins/hover-annotation";

// Types ----

type TimeSeriesChartProps = {
  datasets: Array<ChartDataset<'line', any>>
  labels: Array<string>
  xAxis: string
  yAxis: string
  ySuffix?: string
}

// Component ----

function TimeSeriesChart({datasets, labels, xAxis, yAxis, ySuffix}: TimeSeriesChartProps) {

  const chartData: ChartData<'line', any> = {
    labels: labels,
    datasets: datasets
  }

  const chartOptions: ChartOptions<'line'> = {
    plugins: {
      legend: {
        display: true,
      },
      tooltip: {
        mode: "index",
        intersect: false,
        callbacks: {
          label: context => context.dataset.label +  ': ' + context.parsed.y.toLocaleString() + (ySuffix ?? '')
        }
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: xAxis
        },
      },
      y: {
        title: {
          display: true,
          text: yAxis
        },
        grid: {
          display: true
        },
        min: 0
      }
    }
  }

  return (
    <LineChart data={chartData} options={chartOptions} plugins={[HoverAnnotation]}/>
  );
}

// Export ----

export default TimeSeriesChart;